import React, { useState } from "react";
import {
  // DetailsRow,
  ActionButtonForUser,
  PageInnerContainer,
  // UserFollowingDetails,
  UserInfoBox,
  // UserProfileInfo,
  UserProfileInfo2,
  ReportVideoStyle
} from "../../../GobalStyled";
// import ReportVideo from "./component/ReportVideo";
import ReportInfo from "./component/ReportInfo";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { deleteVideo, activateDeactivate, clearMemoryReport } from "../Auth/_redux/authCrud";
import DeleteBlock from "../Modals/DeleteBlock";
// import ReportInfo from "./components/ReportInfo";

export default function ViewReportedVideo(props) {
  // console.log(props.location.state.data)
  const [activeTab, setActiveTab] = useState("info");
  const [loading, setLoading] = useState(false);
  const [modalLoder, setModalLoder] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [parameter, setParameter] = useState({});
  const [userData, setUserData] = useState(props.location.state.data);
  // console.log(userData)

  const baseurl = "https://d17am3tdlggecz.cloudfront.net/";
  const VideoPreview = ({ src }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    if (error) {
      return (
        <div
          style={{
            width: "150px",
            height: "90px",
            background: "#ffe6e6",
            color: "#d32f2f",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            fontSize: "12px",
          }}
        >
          Video not available
        </div>
      );
    }

    return (
      <>
        {loading && (
          <div
            style={{
              width: "150px",
              height: "90px",
              background: "#f2f2f2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              fontSize: "12px",
            }}
          >
            Loading...
          </div>
        )}

        <video
          src={src}
          autoPlay
          muted
          playsInline
          style={{
            width: "150px",
            borderRadius: "8px",
            display: loading ? "none" : "block",
          }}
          onLoadedData={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      </>
    );
  };
  const deleteAction = async () => {
    setModalLoder(true);
    if (parameter.name === "Delete") {
      // const url = parameter.url;
      let res = await deleteVideo(userData?._id, userData?.mediaUrls?.[0]);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        setLoading(false);
        history.push(props?.location?.state?.path);
        setUserData([]);
        toast.info(res.message, { theme: "colored" });
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
    if (parameter.name === "Activate" || parameter.name === "Deactivate") {
      // const cleanUrl = parameter?.url?.split("?")[0];
      // console.log(cleanUrl)
      let res = await activateDeactivate(userData?._id, userData?.mediaUrls?.[0]);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        history.push(props?.location?.state?.path);
        // getDetails();
        toast.info(res.message, { theme: "colored" });
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
    if (parameter.name === "Clear") {
      let req = {
        reportIds: userData?.reportData?.map(report => report._id),
        memoryId: userData?._id,
      }
      // console.log(req)

      let res = await clearMemoryReport(req);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        toast.info(res.message, { theme: "colored" });
        history.push(props?.location?.state?.path);
        setUserData([]);
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
  };
  const activDeactivate = (type, id, url) => {
    if (type === "Deactivate") {
      setOpenModal(true);
      let para = {
        name: "Deactivate",
        body: "this Video",
        id: id,
        url: url,
      };
      setParameter(para);
    } else {
      setOpenModal(true);
      let para = {
        name: "Activate",
        body: "this Video",
        id: id,
        url: url,
      };
      setParameter(para);
    }
  };

  const DeleteReport = (id) => {
    setOpenModal(true);
    let para = {
      name: "Delete",
      body: "this Video",
      id: id,
    };
    setParameter(para);
  };

  const clearReportAction = (id) => {
    setOpenModal(true);
    let para = {
      name: "Clear",
      body: "this Video",
      id: id,
    };
    setParameter(para);
  };
  const history = useHistory();
  if (loading) {
    return (
      <div className="LoaderWrapper">
        <div className="BackgroundLoader" />
      </div>
    );
  }

  return (
    <>
      {openModal && (
        <DeleteBlock
          open={openModal}
          close={() => setOpenModal(false)}
          confirmSumbit={deleteAction}
          parameter={parameter}
          loading={modalLoder}
        />
      )}

      {userData !== "" ? (
        <PageInnerContainer>
          <UserInfoBox >
            <ReportVideoStyle>



              <div className="px-4">
                <VideoPreview src={baseurl + userData?.mediaUrls?.[0]} />
              </div>

              <UserProfileInfo2>
                <div className="d-flex flex-column gap-2 align-items-start justify-content-start">
                  {userData?.postProfileNewData?.[0]?.postProfile_picture &&
                    userData?.postProfileNewData?.[0]?.postProfile_picture.length > 0 &&
                    userData?.postProfileNewData?.[0]?.postProfile_picture.find(
                      (img) =>
                        img.toLowerCase().endsWith(".jpg") ||
                        img.toLowerCase().endsWith(".jpeg") ||
                        img.toLowerCase().endsWith(".png")
                    ) ? (
                    <button onClick={() =>
                      history.push("/user-details", {
                        id: userData.postProfileNewData[0]?._id,
                        path: props?.location?.state?.path,
                      })
                    }
                      style={{ padding: 0, border: "none", background: "none" }}>
                      <img
                        src={
                          baseurl +
                          userData?.postProfileNewData?.[0]?.postProfile_picture.find(
                            (img) =>
                              img.toLowerCase().endsWith(".jpg") ||
                              img.toLowerCase().endsWith(".jpeg") ||
                              img.toLowerCase().endsWith(".png")
                          )
                        }
                        alt="Profile"
                      />
                    </button>
                  ) : userData?.gender === "male" ? (
                    <button onClick={() =>
                      history.push("/user-details", {
                        id: userData._id,
                        path: props?.location?.state?.path,
                      })
                    }
                      style={{ padding: 0, border: "none", background: "none" }}>
                      <img src="../media/svg/avatars/001-boy.svg" alt="Profile" />
                    </button>
                  ) : (
                    <button onClick={() =>
                      history.push("/user-details", {
                        id: userData._id,
                        path: props?.location?.state?.path,
                      })
                    }
                      style={{ padding: 0, border: "none", background: "none" }}>
                      <img src="../media/svg/avatars/002-girl.svg" alt="Profile" />
                    </button>
                  )}</div>
                <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                  <div>
                    {userData?.postProfileNewData?.length === 0 ? (
                      <div style={{ marginRight: "10px" }}>
                        <h4>Unknown</h4>
                      </div>
                    ) : (

                      <div>
                        {userData?.postProfileNewData?.map((item) => (
                          <button onClick={() =>
                            history.push("/user-details", {
                              id: item._id,
                              path: props?.location?.state?.path,
                            })
                          }
                            style={{ padding: 0, border: "none", background: "none", marginRight: "10px" }} key={item._id}>
                            <h4>
                              @ {item.first_name || "Undefined"}{" "}
                              {item.last_name || ""}
                            </h4>

                          </button>
                        ))}
                      </div>


                    )}
                  </div>
                  <div className="d-flex flex-column gap-6 align-items-center justify-content-center mt-8">
                    <p >{userData?.count}</p>
                    <p className="text-[#000] text-sm text-center">Number of Reports</p>
                  </div>
                </div>


              </UserProfileInfo2>

            </ReportVideoStyle>
            <ActionButtonForUser>
              {/* {userData?.mediaUrls?.filter(item => item.includes("isDeactivated=true")) ? ( */}
              {userData?.deletedByAdmin === true ? (null) : (
                <span
                  className="bg-warning"
                  style={{ padding: "10px", borderRadius: "25px" }}
                  onClick={() => activDeactivate("Deactivate", userData?.mediaUrls?.[0])}
                >
                  Deactivate Video
                </span>
              )}
              {/* ) : (
                <span
                  className="bg-success"
                  style={{ padding: "10px", borderRadius: "25px" }}
                  onClick={() => activDeactivate("Activate", userData?.mediaUrls?.[0])}
                >
                  Activate Video
                </span> 
              )} */}
              {userData?.deletedByAdmin === true ? (<span
                className="Delete"
              // onClick={() => DeleteReport(userData?.mediaUrls?.[0])}
              >
                Deleted
              </span>) : (
                <span
                  className="Delete"
                  onClick={() => DeleteReport(userData?.mediaUrls?.[0])}
                >
                  Delete Video
                </span>
              )}
              <span
                className="clear bg-success text-white"
                style={{ padding: "10px", borderRadius: "25px" }}
                onClick={() => clearReportAction(userData?.reportData?._id)}
              >
                Clear
              </span>
            </ActionButtonForUser>
            {/* <UserFollowingDetails>
              <div>
                <p>{userData?.count}</p>
                <span>Number of Reports</span>
              </div>
            </UserFollowingDetails> */}

          </UserInfoBox>



          {/* <div className="row">

            
            <div className="col-xl-8 col-12">
              <div className=" rounded shadow p-6">
                <h3 className="mb-5">Reported Video</h3>

                <div className="d-flex align-items-center gap-4">
                  <VideoPreview src={baseurl + userData?.mediaUrls?.[0]} />

                  <div>
                    <h4 className="text-primary font-weight-bold">
                      {userData?.postProfileNewData?.[0]?.first_name || "Unknown"}
                    </h4>

                    <p className="text-muted">Number of reports</p>

                    <div className="report-circle">
                      {userData?.count}
                    </div>

                    <p className="text-muted mt-2">Report Count</p>
                  </div>
                </div>
              </div>
            </div>


            
            <div className="col-xl-4 col-12">
              <div className=" rounded shadow p-6">

                <h4 className="mb-4">Report Count: {userData?.count}</h4>

                <div className="d-flex flex-column gap-3">

                  <button
                    className="btn btn-light"
                    onClick={() =>
                      activDeactivate("Deactivate", userData?.mediaUrls?.[0])
                    }
                  >
                    Deactivate
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => DeleteReport(userData?.mediaUrls?.[0])}
                  >
                    Delete
                  </button>

                  <button
                    className="btn btn-light"
                    onClick={() => clearReportAction(userData?.reportData?._id)}
                  >
                    Clear
                  </button>

                </div>
              </div>
            </div>

          </div> */}


          <div
            style={{
              textAlign: "center",
              borderBottom: "2px solid red",
              fontSize: "2rem",
              fontWeight: "500",
              paddingTop: "2%",
            }}
          >

            <div>
              <span
                className={activeTab === "info" ? "active" : ""}
                onClick={() => setActiveTab("info")}
              >
                Report Info
              </span>
            </div>
            {/* <div>
              <span
                className={activeTab === "video" ? "active" : ""}
                onClick={() => setActiveTab("video")}
              >
                Reported Video
              </span>
            </div> */}
          </div>


          {activeTab === "info" ? (
            // <ReportedDeactivated key="deactivatedTab" data={userData} />
            <ReportInfo key="infoTab" data={userData?.reportedByUserData} reportData={userData?.reportData} />
          ) : null}
          {/* {activeTab === "video" ? (
            <ReportVideo key="videoTab" data={userData} />
          ) : null} */}
        </PageInnerContainer >
      ) : (
        <span className="ml-3 spinner spinner-white"></span>
      )
      }
    </>
  );
}
